/* tslint:disable */
export var icon = "\n<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"6\" height=\"8\"><path d=\"M2.613.183a.499.499 0 01.774 0L5.884 3.18a.5.5 0 11-.768.64L3.5 1.881V7.5a.5.5 0 01-1 0V1.881L.884 3.821a.5.5 0 11-.768-.641L2.613.183z\"/></svg>\n";
//# sourceMappingURL=percentage-arrow.svg.js.map